import { Application, MBS2MRHelper, MBSAccessHelper, Module, Privilege } from '@fides/fides-react-components';
import { User } from '../models';

const hasAdminOrEditPermission = (accessHelper: MBSAccessHelper, module: Module): boolean => {
  return (
    accessHelper.hasPermissionForModule(module, Privilege.ADMIN) ||
    accessHelper.hasPermissionForModule(module, Privilege.EDIT)
  );
};

export const addAndEditPageAccessGranted = (
  accessHelper: MBSAccessHelper,
  user: User,
  module: Module,
  application: Application
): boolean => {
  const clientLvlImpersonation = accessHelper.isImpersonatedAsClient && accessHelper.isFidesAdministrator(application);

  const userLvlImpersonation = user.impersonatedUser && hasAdminOrEditPermission(accessHelper, module);

  return (
    (hasAdminOrEditPermission(accessHelper, module) && !user.impersonated) ||
    clientLvlImpersonation ||
    userLvlImpersonation
  );
};

export const deleteGranted = (
  accessHelper: MBSAccessHelper,
  user: User,
  module: Module,
  application: Application
): boolean => {
  const clientLvlImpersonation = accessHelper.isImpersonatedAsClient && accessHelper.isFidesAdministrator(application);

  const userLvlImpersonation =
    user.impersonatedUser &&
    hasAdminOrEditPermission(accessHelper, module) &&
    accessHelper.isFidesAdministrator(application);

  return (
    (hasAdminOrEditPermission(accessHelper, module) && !user.impersonated) ||
    clientLvlImpersonation ||
    userLvlImpersonation
  );
};

export const TwoMREnabled = (twoMRHelper: MBS2MRHelper, module: Module): boolean =>
  twoMRHelper.is2MREnabled && twoMRHelper.is2MREnabledFor(module);
